'use strict';

var _ = require('lodash');
function DemandCalendarFilterFactory(DataFilter, featureToggleService) {
  function DemandCalendarFilter() {
    DataFilter.call(this, ['seasonality-show-up-mode'], 'seasonality-demand-calendars', 4);
  }
  DemandCalendarFilter.constructor = DemandCalendarFilter;
  DemandCalendarFilter.prototype = Object.create(DataFilter.prototype);
  DemandCalendarFilter.prototype.filter = function demandCalendarFilter(data) {
    if (!featureToggleService.isEnabled('DYNAMIC_AVAILABILITY;DYNAMIC_AVAILABILITY_SEASONALITY')) {
      return data;
    }
    var errored = _.chain(data).remove({
      calendarStatus: 'error'
    }).groupBy('market').map(function (markets) {
      return _.last(markets);
    }).value() || [];
    return _.concat(errored, data);
  };
  return DemandCalendarFilter;
}
DemandCalendarFilterFactory.$inject = ['DataFilterFactory', 'FeatureToggleService'];
module.exports = DemandCalendarFilterFactory;